import { useContext, type PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

import { AriaLabelForContext } from "@/contexts/AriaLabelForContext";

export function Subtitle({ id, children, className }: PropsWithChildren<{ id?: string; className?: string }>) {
  const labelId = useContext(AriaLabelForContext);
  return (
    <h2 id={id ?? labelId} className={twMerge("font-subtitle", className)}>
      {children}
    </h2>
  );
}
